import { Routes, Route, Navigate } from "react-router-dom";
import BaseLayout from "../Components/BaseLayout";
import Home from "../Pages/Home";
import ContactUs from "../Pages/ContactUs/ContactUs";
import Services from "../Pages/Services/Services";
import OurPolicies from "../Pages/OurPolicies/Ourpolicies";
import EMICalculator from "../Pages/EmiCalc/EmiCalc";
import { RedirectLink } from "../constants/constants";
import BasePageLayout from "../Components/BasePageLayout";
import AboutUs from "../Pages/AboutUs/AboutUs";
import Payments from "../Pages/Payments/Payments";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<BaseLayout />}>
        <Route path="" element={<Home />} />
        <Route path="/" element={<BasePageLayout />}>
          <Route path={RedirectLink.ContactUs} element={<ContactUs />} />
          <Route path={RedirectLink.OurPolices} element={<OurPolicies />} />
          <Route path={RedirectLink.Services} element={<Services />} />
          <Route path={RedirectLink.AboutUs} element={<AboutUs />} />
          <Route path={RedirectLink.Payments} element={<Payments />} />
          <Route
            path={RedirectLink.EMICalculator}
            element={<EMICalculator />}
          />
          <Route path="*" element={<Navigate to={RedirectLink.HOME} />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default AppRoutes;
